import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { ProductIntro } from './components/ProductIntro';
import { WhatsIncluded } from './components/WhatsIncluded';
import { TransformationSection } from './components/TransformationSection';
import { BonusStack } from './components/BonusStack';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1421502962259206';
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Avoid injecting the pixel twice (e.g. hot reload / re-mount)
    if (document.getElementById('meta-pixel-script')) return;
    const script = document.createElement('script');
    script.id = 'meta-pixel-script';
    // Official Meta Pixel snippet, verbatim
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen bg-ink font-sans text-white selection:bg-brightGreen selection:text-ink" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <TopBar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <SocialProofBar data-id="element-6" />
        <PainSection data-id="element-7" />
        <AgitationSection data-id="element-8" />
        <ProductIntro data-id="element-9" />
        <WhatsIncluded data-id="element-10" />
        <TransformationSection data-id="element-11" />
        <BonusStack data-id="element-12" />
        <PricingSection data-id="element-13" />
        <Testimonials data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <ClosingCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}